﻿import { ApiCaller } from 'apis/ApiCaller';

export interface AccessCode {
	DateAdd: string;
	ExpirationDate: string;
	Id: number;
	Name: string;
	Redeem: number;
	Remaining: number;
	TransactionId: number;
}

export class AccessCodeApi {

    private static apiCaller = new ApiCaller('AccessCode');

    public static GetAll(studentId: number) : Promise<AccessCode[]> {

	    return this.apiCaller.GET<AccessCode[]>('GetAll', { studentId });

    }

}